import { render, staticRenderFns } from "./ClaudeView.vue?vue&type=template&id=3a095c85&scoped=true"
import script from "./ClaudeView.vue?vue&type=script&lang=js"
export * from "./ClaudeView.vue?vue&type=script&lang=js"
import style0 from "./ClaudeView.vue?vue&type=style&index=0&id=3a095c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a095c85",
  null
  
)

export default component.exports